
import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class ReporteEmbarqueSector12Linea5Service {
  static async getDataReporteEmbarqueSector12Linea5 (cereal, cerealVariedad, etiqueta) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_vejez_sector12_linea5?r={"clave":{"cereal":"${cereal}","cereal_variedad":"${cerealVariedad}","etiqueta":"${etiqueta}"}}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de embarque sector 1-2.')
      return (data)
    })
  }

  static async getDataReporteEmbarqueSector12Linea5Total (cereal, cerealVariedad, etiqueta) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_vejez_sector12_linea5_total?r={"clave":{"cereal":"${cereal}","cereal_variedad":"${cerealVariedad}","etiqueta":"${etiqueta}"}}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de embarque sector 1-2.')
      return (data)
    })
  }
}
